/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Close = ({ color, height = 20, ...props }) => {
  return (
    <svg
      width={20}
      height={height}
      viewBox="0 0 20 20"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.446 10L20 18.554 18.553 20 10 11.446 1.446 20 0 18.554 8.553 10 0 1.446 1.446 0 10 8.554 18.553 0 20 1.446 11.446 10z"
      />
    </svg>
  )
}

Close.propTypes = {
  color: string,
  height: number,
}

export default Close
